import { formatCount } from '../utils/author';

function ViewCount({ count }) {
    const total = Number(count) || 0;

    return (
        <span className="vote-count" title="Times this post has been viewed">
            <span aria-hidden="true">👁</span> {formatCount(total)} {total === 1 ? 'view' : 'views'}
        </span>
    );
}

export default ViewCount;
